import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { examApi } from '../lib/api';
import { useExamStore } from '../stores/examStore';

export function useExams(params?: { status?: string; class_id?: number }) {
  return useQuery({
    queryKey: ['exams', params],
    queryFn: async () => {
      const res = await examApi.getExams(params);
      return res.data;
    },
  });
}

export function useExam(id: number) {
  return useQuery({
    queryKey: ['exam', id],
    queryFn: async () => {
      const res = await examApi.getExam(id);
      return res.data;
    },
    enabled: !!id,
  });
}

export function useStartExam() {
  const queryClient = useQueryClient();
  const { setCurrentAttempt } = useExamStore();

  return useMutation({
    mutationFn: async (examId: number) => {
      const res = await examApi.startExam(examId);
      return res.data;
    },
    onSuccess: (data) => {
      setCurrentAttempt(data);
      queryClient.invalidateQueries({ queryKey: ['exams'] });
    },
  });
}

export function useSubmitExam() {
  const queryClient = useQueryClient();
  const { clearExam } = useExamStore();

  return useMutation({
    mutationFn: async ({ examId, answers }: { examId: number; answers: { questionId: number; selectedOption?: string }[] }) => {
      const res = await examApi.submitExam(examId, answers);
      return res.data;
    },
    onSuccess: () => {
      clearExam();
      queryClient.invalidateQueries({ queryKey: ['exams'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });
}

export function useExamResult(examId: number) {
  return useQuery({
    queryKey: ['exam-result', examId],
    queryFn: async () => {
      const res = await examApi.getResult(examId);
      return res.data;
    },
    enabled: !!examId,
  });
}
